import { apiPatch } from '../client';
import { BusinessProfileSchema, type BusinessProfile, type ScheduleDay } from '../schemas';

export type UpdateScheduleInput = {
  businessId: string;
  hours: ScheduleDay[];
  staffHours?: Record<string, ScheduleDay[]>;
  classTimes?: string[];
};

export function updateSchedule(
  input: UpdateScheduleInput,
  idempotencyKey: string,
): Promise<BusinessProfile> {
  const { businessId, ...body } = input;
  return apiPatch(
    `/v1/businesses/${encodeURIComponent(businessId)}/schedule`,
    BusinessProfileSchema,
    body,
    idempotencyKey,
  );
}
